import {
    CcLibraryItem,
    CcLibraryItemList,
    CcReviewComplianceRevision,
    CcReviewComplianceItemState,
    CcReviewComplianceHistory,
} from "server/models"
import { inferLiteral, StateType } from "client/utils"
import { TableGroupedIds } from "client/components"
import { CcLibrarySetList } from "client/store"
import * as types from "./types"

// list
export const showCcReviewComplianceFormalColumnSettings = (show: boolean) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_FORMAL_COLUMN_SETTINGS),
    show,
})
export const showCcReviewComplianceColumnSettings = (show: boolean) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_COLUMN_SETTINGS),
    show,
})


export const setCcReviewComplianceItemList = (itemList: CcLibraryItemList) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_ITEM_LIST),
    itemList,
})
export const setCcReviewComplianceItemGroupedIds = (setId: number, groupedIds: TableGroupedIds) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_ITEM_GROUPED_IDS),
    setId,
    groupedIds,
})
export const clearCcReviewComplianceItemGroupedIds = () => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_CLEAR_ITEM_GROUPED_IDS),
})


export const setCcReviewComplianceSetList = (setList: CcLibrarySetList) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_SET_LIST),
    setList,
})
export const setCcReviewComplianceSetIds = (setIds: readonly number[]) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_SET_IDS),
    setIds,
})


export const setCcReviewComplianceRevisionList = (setId: number, revisions: CcReviewComplianceRevision[]) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_REVISION_LIST),
    setId,
    revisions,
})
export const setCcReviewComplianceRevisionActive = (versionId: number, setId: number, revision: CcReviewComplianceRevision) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_REVISION_ACTIVE_LIST),
    versionId,
    setId,
    revision,
})


export const setCcReviewComplianceItemStateList = (setId: number, itemStateList: types.ReviewComplianceStateList) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_ITEM_STATE_LIST),
    setId,
    itemStateList,
})
export const setCcReviewComplianceItemHistoryList = (setId: number, itemHistoryList: types.ReviewComplianceHistoryList) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_ITEM_HISTORY_LIST),
    setId,
    itemHistoryList,
})
export const setCcReviewComplianceTempAnswerList = (setId: number, tempAnswerList: types.ReviewComplianceTempAnswerList) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_TEMP_ANSWER_LIST),
    setId,
    tempAnswerList,
})


// selected items
export const setCcReviewComplianceFormalSelectedItemIds = (selected: readonly number[]) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_FORMAL_SELECTED_ITEM_IDS),
    selected,
})
export const setCcReviewComplianceFormalVisibleItemIds = (visible: readonly number[]) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_FORMAL_VISIBLE_ITEM_IDS),
    visible,
})
export const setCcReviewComplianceSelectedItemIds = (selected: readonly number[]) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_SELECTED_ITEM_IDS),
    selected,
})
export const setCcReviewComplianceVisibleItemIds = (visible: readonly number[]) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_VISIBLE_ITEM_IDS),
    visible,
})


export const setCcReviewComplianceSetLoadState = (state: StateType) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_SET_LOAD_STATE),
    state,
})
export const setCcReviewComplianceItemLoadState = (state: StateType) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_ITEM_LOAD_STATE),
    state,
})


// popup menu
export const setCcReviewComplianceActive = (active: CcLibraryItem) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_ACTIVE),
    active,
})
export const setCcReviewCompliancePopupMenuShow = (show: boolean) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_POPUP_MENU_SHOW),
    show,
})
export const setCcReviewCompliancePopupMenuTarget = (target: HTMLElement) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_POPUP_MENU_TARGET),
    target,
})


// view history
export const setCcReviewComplianceItemDetails = (details: CcLibraryItem) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_ITEM_DETAILS),
    details,
})
export const setCcReviewComplianceItemState = (state: CcReviewComplianceItemState) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_ITEM_STATE),
    state,
})
export const setCcReviewComplianceItemHistory = (history: CcReviewComplianceHistory[]) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_ITEM_HISTORY),
    history,
})
export const setCcReviewComplianceTempAnswers = (answers: types.ReviewComplianceTempAnswerByUser) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_TEMP_ANSWERS),
    answers,
})
export const setCcReviewComplianceTempAnswerVersions = (versions: types.ReviewComplianceTempAnswerVersionByUser) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_TEMP_ANSWER_VERSIONS),
    versions,
})
export const setCcReviewComplianceTempAnswerHistory = (history: CcReviewComplianceHistory) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_TEMP_ANSWER_HISTORY),
    history,
})
export const setCcReviewComplianceReloadAnswer = (value: boolean) => ({
    type: inferLiteral(types.CC_REVIEW_COMPLIANCE_RELOAD_ANSWER),
    value,
})
